<template>
  <component :is="challengeNotStartedComponent" />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useChallengeStore } from '../../stores/challenge';
import { ChallengeTypeEnum } from '../../types/challenge';
import ContentBasedChallengeNotStarted from './ContentBasedChallengeNotStarted.vue';
import DefaultChallengeNotStarted from './DefaultChallengeNotStarted.vue';

const challengeStore = useChallengeStore();
const { challenge } = storeToRefs(challengeStore);

const challengeTypeToNotStarted = {
  [ChallengeTypeEnum.Values.contentBased]: ContentBasedChallengeNotStarted,
  valueBased: DefaultChallengeNotStarted,
  dailyTaskBased: DefaultChallengeNotStarted,
  percentBased: DefaultChallengeNotStarted,
  personalValueBased: DefaultChallengeNotStarted,
};
const challengeNotStartedComponent = challengeTypeToNotStarted[challenge.value.type];
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/spacings';
@import '@riseupil/base-ui/src/scss/riseup-colors';

.header-section {
  height: 198px;
  display: grid;
  grid-template-columns: 2.5fr 0.5fr;
  gap: 16px;

  .header-texts {
    display: flex;
    flex-direction: column;
    align-self: center;

  }
}

.challenge-info {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: $ri-spacing-m;

  .separator {
    border-bottom: 1px solid $riseup_gray_0;
  }
}
</style>
